import React from 'react'
import * as R from 'ramda'
import BasePlacesAutocompleteFormsy from './BasePlacesAutocompleteFormsy'

const PlacesNameAutocompleteFormsy = (props) => {
  return (
    <BasePlacesAutocompleteFormsy
      {...props}
      parseValue={
        props.parseValue || R.pathOr('', ['formattedSuggestion', 'mainText'])
      }
    />
  )
}

export default PlacesNameAutocompleteFormsy
